import { useEffect, useState } from "react";
import {
  isPremiumActive,
  subscribePremiumPlan,
} from "../utils/premiumPlan";

export default function usePremiumPlan(userId) {
  const [isPremium, setIsPremium] = useState(() => isPremiumActive(userId));

  useEffect(() => {
    setIsPremium(isPremiumActive(userId));
    return subscribePremiumPlan((data) => {
      setIsPremium(data?.userId === userId && Boolean(data?.planId));
    });
  }, [userId]);

  return isPremium;
}
